import store from '@/store/index.js'

export function paginationMiddleware() {
  store.commit('pagination/setCurrentPage', 1)
  store.commit('pagination/setMaxPage', 1)
}
